import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tag, ArrowUpRight, Zap } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/contexts/AppContext";

export const DealsCarousel = () => {
  const { location } = useApp();
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    const params = location ? { lat: location.lat, lon: location.lon } : {};
    api.get("/deals", { params }).then((r) => setDeals(r.data.results.slice(0, 8)));
  }, [location]);

  if (deals.length === 0) return null;

  return (
    <section className="container-narrow mt-24">
      <div className="flex items-end justify-between mb-7">
        <div>
          <div className="eyebrow mb-2 flex items-center gap-2">
            <Tag className="w-3.5 h-3.5 text-rose-300" strokeWidth={1.8} />{" "}
            Today's Deals
          </div>
          <h2 className="font-serif text-4xl">
            <span className="italic gold">Specials</span> across PA
          </h2>
        </div>
        <Link
          to="/search?deals=1"
          data-testid="home-see-deals"
          className="text-sm text-foreground/70 hover:text-foreground flex items-center gap-1"
        >
          Browse all <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {deals.map((d) => {
          const discount = Math.round(
            ((d.original_price - d.price) / d.original_price) * 100
          );
          return (
            <Link
              key={d.id}
              to={`/dispensaries/${d.dispensary_id}`}
              data-testid={`deal-card-${d.id}`}
              className="card-hover bg-card border border-border rounded-2xl overflow-hidden block relative"
            >
              <div className="aspect-square bg-secondary overflow-hidden relative">
                <img
                  src={d.image_url}
                  alt={d.strain_name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-card/70 via-transparent to-transparent" />
                <div className="absolute top-3 left-3 flex flex-col gap-1.5">
                  <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] font-bold px-2 py-1 rounded-full border bg-rose-500/20 text-rose-300 border-rose-500/40">
                    <Tag className="w-3 h-3" strokeWidth={2.4} />
                    {discount}% OFF
                  </span>
                  {d.boosted && (
                    <span
                      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] font-semibold px-2 py-1 rounded-full border"
                      style={{
                        color: "#D4A268",
                        borderColor: "rgba(212,162,104,0.5)",
                        background: "rgba(212,162,104,0.12)",
                      }}
                    >
                      <Zap className="w-3 h-3" strokeWidth={2.4} /> Sponsored
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4">
                <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                  {d.deal_label || "Deal of the Day"}
                </div>
                <div className="font-serif text-lg leading-tight mt-0.5">
                  {d.strain_name}
                </div>
                <div className="text-xs text-muted-foreground mt-1">
                  {d.dispensary_name}
                </div>
                <div className="flex items-baseline gap-2 mt-3">
                  <span className="price-tag text-xl">${d.price.toFixed(2)}</span>
                  <span className="text-xs text-muted-foreground line-through">
                    ${d.original_price.toFixed(2)}
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground ml-auto">
                    {d.unit}
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
